import tw from 'twin.macro'
import React from 'react'
import { Tooltip } from '../Tooltip/Tooltip'

function Tag({ text, tooltipText, remove, className, ...otherProps }) {
  const handleClick = (e) => {
    e.stopPropagation()
    remove(text)
  }

  return (
    <TagContainer {...otherProps} className={className}>
      {Boolean(tooltipText) && (
        <Tooltip
          content={tooltipText}
          triggerClasses='absolute -top-1.5 -left-1.5 flex items-center justify-center text-xxs text-black leading-none w-3.5 h-3.5 rounded-full bg-white border-black border cursor-pointer'
        >
          ?
        </Tooltip>
      )}
      <span className='break-all' data-testid='tag'>
        {text}
      </span>{' '}
      {remove && (
        <button className='ml-2' type='button' aria-label={`remove ${text} tag`} onClick={handleClick} tabIndex={-1}>
          &#10005;
        </button>
      )}
    </TagContainer>
  )
}

const TagContainer = tw.span`relative mr-2 mb-2 py-1 px-2 inline-flex text-sm leading-5 font-semibold rounded-lg bg-offWhite text-tBlack text-opacity-70`

export default Tag
